import { PrismicRichText } from "@prismicio/react";
import React from "react";
import { PrismicReusableContentDataBodyHoverCard } from "../../types/graphql";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { clsx } from "clsx";
import { graphql } from "gatsby";

export const query = graphql`
  fragment HoverCardModule on PrismicReusableContentDataBody {
    ... on PrismicReusableContentDataBodyHoverCard {
      slice_type
      primary {
        css_class
        heading {
          richText
          text
        }
        description {
          richText
          text
        }
        image {
          gatsbyImageData
          url
          alt
        }
        cta_text
        cta_link {
          url
          target
        }
        cta_type
      }
    }
  }
`;

export type IHoverCardProps = {
  slice: PrismicReusableContentDataBodyHoverCard;
};

const HoverCard = (props: IHoverCardProps) => {
  const { slice } = props;
  const { primary } = slice;

  return (
    <div
      className={clsx([
        "col-span-2 lg:col-span-3 bg-cover rounded-lg aspect-square",
        "[&>.card-info]:grid [&>.card-info]:!grid-cols-1 [&>.card-info]:gap-4",
        "[&>.card-info]:content-center [&>.card-info]:justify-items-center",
        "[&>.card-info]:px-4",
        "[&>.card-info]:text-center [&>.card-info]:rounded-lg",
        "[&>.card-info]:bg-black/50 [&>.card-info]:h-full",
        "[&>.card-info]:cursor-pointer",
        "[&>.card-info>h5]:!text-white [&>.card-info]:aspect-square [&>.card-info&>h5]:mb-0",
        "hover:[&>.card-info]:hidden hover:!bg-none hover:!bg-[#0E6AED] hover:p-4",
        "[&>.card-info-hover]:aspect-square [&>.card-info-hover]:h-full",
        "hover:[&>.card-info-hover]:!grid [&>.card-info-hover]:!grid-cols-1 [&>.card-info-hover]:gap-2",
        "hover:[&>.card-info-hover]:place-content-center",
        "[&>.card-info-hover]:!text-white [&>.card-info-hover>h5]:!text-white [&>.card-info-hover]:rounded-lg",
        "[&>.card-info-hover]:text-center [&>.card-info-hover]:p-4",
        "[&>.card-info-hover]:border-1 [&>.card-info-hover]:border-white",
        "[&>.card-info-hover]:cursor-pointer",
        primary?.css_class,
      ])}
      style={{ backgroundImage: `url(${primary.image?.url})` }}
    >
      <div className="card-info">
        <PrismicRichText
          field={primary.heading.richText}
          components={htmlSerializer}
        />
      </div>
      <div className="card-info-hover hidden">
        <PrismicRichText
          field={primary.heading.richText}
          components={htmlSerializer}
        />
        <PrismicRichText
          field={primary.description.richText}
          components={htmlSerializer}
        />
      </div>
    </div>
  );
};

export default HoverCard;
